import React from "react";
import { EnquiryTopBanner } from "../components/EnquiryTopBanner";
import { enquiryOperationsList } from "../constants/enquiry.constants";
import {
  Box,
  Card,
  CardContent,
  Grid2 as Grid,
  List,
  ListItem,
  ListItemText,
  Rating,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEnquiryContext } from "../context";
import dayjs from "configs/dayjs.config";

import { dateTimeFormat } from "constants/componentsConstants";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { Link } from "react-router-dom";

export const PreviewEnquiry = () => {
  const { previewEnquiry: record } = useEnquiryContext();
  return (
    <>
      <PageTitle pageName={pageName.enquiry.previewEnquiry} />
      <EnquiryTopBanner
        buttonType="back"
        enquiryOperationsParam={enquiryOperationsList.listEnquiry}
      />
      <Card>
        <CardContent>
          <Grid container spacing={5}>
            <Box>
              <Typography variant="h6">Client Information</Typography>
              <List>
                <ListItem>
                  <ListItemText primary="Name" secondary={record.clientName} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Type" secondary={record.clientType} />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Contact No"
                    secondary={record.clientContactNo}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Email"
                    secondary={record.clientEmail}
                  />
                </ListItem>
                <ListItem>
                  <FlexBox flexDirection={"column"}>
                    <Typography component="legend">Weightage</Typography>
                    <Rating value={record.weightage} size="large" readOnly />
                  </FlexBox>
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Delivery Date"
                    secondary={dayjs(record.deliveryDate).format(
                      dateTimeFormat.date
                    )}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Target Conversion Date"
                    secondary={dayjs(record.targetConversionDate).format(
                      dateTimeFormat.date
                    )}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Budget" secondary={record.budget} />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Address"
                    secondary={record.clientAddress}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText primary="City" secondary={record.clientCity} />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Status Updated By / On"
                    secondary={
                      record.statusUpdatedBy +
                      " / [" +
                      dayjs(record.statusUpdatedOn).format(
                        dateTimeFormat.date
                      ) +
                      "]"
                    }
                  />
                </ListItem>
                <ListItem>
                  <Link to={record.link} target="_blank">
                    <ListItemText primary="Link" secondary={record.link} />
                  </Link>
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="BDC"
                    secondary={
                      record.createdBy +
                      " / [" +
                      dayjs(record.createdOn).format(dateTimeFormat.date) +
                      "]"
                    }
                  />
                </ListItem>
              </List>
            </Box>

            <Box flexGrow={1}>
              <Typography variant="h6">POC Information</Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    {record.pocList.map((poc, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Box>POC : {index + 1}</Box>
                          <Box>Name : {poc.pocName}</Box>
                          <Box>Designation : {poc.pocDesignation}</Box>
                          <Box>Contact : {poc.pocContact}</Box>
                          <Box>Email : {poc.pocEmail}</Box>
                          <Box>Contact Other 1 : {poc.pocContactOther}</Box>
                          <Box>Email Other 1 : {poc.pocEmailOther}</Box>
                          <Box>Contact Other 2 : {poc.pocContactOther2}</Box>
                          <Box>Email Other 2 : {poc.pocEmailOther2}</Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableHead>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
